import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-alert-dialog',
    standalone: true,
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatDialogClose,
        MatButtonModule,
        TranslocoModule,
    ],
    templateUrl: './alert-dialog.component.html',
    styleUrl: './alert-dialog.component.scss',
})
export class AlertDialogComponent {
    title: string = '';
    message: string = '';
    cancelButtonText = 'cancel';
    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogRef: MatDialogRef<AlertDialogComponent>
    ) {
        if (data) {
            this.title = data.title || this.title;
            this.message = data.message || this.message;
            if (data.buttonText) {
                this.cancelButtonText =
                    data.buttonText.cancel || this.cancelButtonText;
            }
        }
        //this.dialogRef.updateSize('300vw', '300vw');
        setTimeout(() => {
            this.dialogRef.close(true);
          }, 5000);
    }

    onConfirmClick(): void {
        this.dialogRef.close(true);
    }
}
